import { PatentFamilySizeOverTime } from "./patent-family-size";
export default PatentFamilySizeOverTime;
